import React, { memo } from "react";
import { Toast } from "primereact/toast";
import { AudioRecorder, useAudioRecorder } from "react-audio-voice-recorder";
import closeIcon from "../../../assets/images/close_modal.svg";
import { AudioRecording } from "../../../sharedComponent/audioRecorder";
import mic from "../../../assets/images/chat/mic.svg";

import {
  Button,
  Dropdown,
  Modal,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  Button as UIButton,
  Modal as UIModal,
  Input as UIInput,
  Table as UITable,
} from "../../../components/ui";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import ic_video_call from "../../../assets/images/chat/ic_video_call.svg";
import bx_phone_call from "../../../assets/images/chat/bx_phone_call.svg";
import more_vertical from "../../../assets/images/chat/more_vertical.svg";
import profile_img from "../../../assets/images/profile_img.svg";
import user_pic2 from "../../../assets/images/profile_img.svg";
import "../../../assets/css/main.scss";
import ic_online from "../../../assets/images/chat/ic_online.svg";
import ic_away from "../../../assets/images/chat/ic_away.svg";
import ic_busy from "../../../assets/images/chat/ic_busy.svg";
import ic_gray from "../../../assets/images/chat/ic_gray.svg";
import ApiConfig from "../../../api/ApiConfig";
import moment from "moment";
import Beatloader from "../../../sharedComponent/Beatloader";
import { notifySuccess } from "../../../toaster/notify";
import Calling from "../../../sharedComponent/Calling";
import Multiselect from "multiselect-react-dropdown";
import Files from "../Files";
import smiley_icon from "../../../assets/images/chat/smiley_icon.svg";
import no_chats from "../../../assets/images/chat/chatsNone.svg";
import BackDropLoader from "../../../sharedComponent/BackDropLoader";
import ChatImage from "../../chatImage";
import { useChatBox } from "../hooks/useChatBox";
import MessageList from "./MessageList";
import Composer from "./Composer";
import UploadTray from "./UploadTray";

const ChatBox = ({
  setShowResults,
  selectedList,
  showResults,
  setSelectedList,
  createChatRoom,
  schannelName,
  setSchannelName,
  updatePinUnpinChat,
  isIndivitual = true,
}) => {
  const navigate = useNavigate();
  const currentRoute = useLocation().pathname;

  const {
    members,
    setMembers,
    addMembers,
    setAddMembers,
    addSubMembers,
    setAddSubMembers,
    files,
    setFiles,
    uploadedFiles,
    setUploadedFiles,
    SubchianlMemberList,
    message,
    setmessage,
    setMembersAdded,
    menstionedUsers,
    setMenstionedUsers,
    selectedReaction,
    setselectedReaction,
    showAudioErr,
    setShowAudioErr,
    closeOutsideClick,
    setCloseOutSideClic,
    emogi,
    setEmogi,
    openVoiceReq,
    setOpenVoiceReq,

    fileUpload,
    toast,
    lastMsg,
    firstMsg,
    pindropdown,
    msgRef,
    inputRef,

    sendMessage,
    activeChat,
    userData,
    socket,
    currentSChannel,
    teamMembers,
    page,
    conversations,
    newMessages,
    userTyping,
    editMsg,
    setEditMsg,
    replyTo,
    setReplyTo,
    noMorePages,
    paginationLoader,
    setPage,
    loading,
    suggetions,
    membersArray,
    setRecentChats,
    recentChats,
    pinnedChats,
    setPinnedChats,
    permissions,

    user,
    last_seen,

    save,
    onSelect,
    onRemove,
    deletMessage,
    pinChat,
    unpinChat,
    removeReaction,
    addCreateTask,
    handleCopyUrl,
    createSubChannelMember,
  } = useChatBox({ setSelectedList, updatePinUnpinChat });

  const items = [
    // Pencil "Add" speed-dial action commented out per request — it was a
    // no-op stub that only showed a toast and confused users into thinking
    // they could edit a message from the composer.
    // {
    //   label: "Add",
    //   icon: "pi pi-pencil",
    //   command: () => {
    //     toast.current.show({
    //       severity: "info",
    //       summary: "Add",
    //       detail: "Data Added",
    //     });
    //   },
    // },
    {
      label: "smiley",
      template: (item, options) => {
        return (
          /* custom element */
          <a
            className={options?.className}
            target={item.target}
            onClick={() => setEmogi((prev) => !prev)}
          >
            <img src={smiley_icon} alt=""></img>
          </a>
        );
      },
      command: () => {
        toast.current.show();
      },
    },
    {
      label: "Upload",
      icon: "pi pi-upload",
      command: () => {
        fileUpload.current.click();
      },
    },
  ];

  return (
    <>
      <Toast ref={toast} className="toast" />
      <div className="comm-chatbox">
        {showResults ? (
          <div className="search-input-wrapper position-relative create-sub-channel" id="search-chat-user">
            <h5><strong>Select Member</strong></h5>
            <Multiselect
              options={suggetions.map((suggetion) => {
                return {
                  id: suggetion.EmployeeId,
                  name: suggetion.FirstName + " " + suggetion.LastName,
                };
              })}
              onSelect={onSelect}
              onRemove={onRemove}
              displayValue="name"
              closeOnSelect="false"
              className=""
            />
            <div className="breakerLine"></div>
            <div className="button">
              <UIButton
                variant="primary"
                className="ml-3 comm-chatbox__start-chat-btn"
                onClick={() => {
                  setShowResults(false);
                  createChatRoom();
                }}
              >
                Start Chat
              </UIButton>
            </div>
            {/* {Dark === "lightMode" ? (
           <img src={searchicon} alt="" />
         ) : (
           <img src={ic_search_dark} alt="" />
         )} */}
            {/* {filteredUsers.length ?
             <div className="suggestion-list-wrapper">

               <ul style={{ listStyleType: "none" }}>
                 {filteredUsers.map((user, index) => {
                   return (
                     <li
                       className="suggestion-item" key={"suggetion" + index}
                       style={{
                         margin: "0",
                         cursor: "pointer"
                       }}
                       onClick={() => {
                         onClick();
                         setActiveChat(user);
                         setCurrentSChannel(null);
                       }}
                     >
                       <div
                         className="user-chat-tab"
                         style={{
                           width: "100%",
                           padding: "10px 20px",
                         }}
                       >
                         <div className="d-flex">
                           <img src={user.PhotoPath ? ApiConfig.BASE_URL_FOR_IMAGES + user.PhotoPath : profile_img} alt="" style={{ borderRadius: "18px", width: "33px", height: "33px" }} />
                           <p>{user.FirstName + " " + user.LastName}</p>

                         </div>
                       </div>
                     </li>

                   )
                 })}
               </ul>
             </div>
             :
             "No User Found"

           } */}
          </div>
        ) : (
          <>
            {currentSChannel || activeChat.Team_Channel_Id ? (
              <>
                <div className="comm-chatbox__header">
                  <div className="comm-chatbox__header-left">
                    <div className="comm-chatbox__header-avatar comm-chatbox__profile-pic-wrap">
                      <Link>
                        {
                          console.log(activeChat, 'Amir')
                        }
                        <ChatImage
                          name={isIndivitual ? user?.FirstName : activeChat?.project?.split(" ")[0]}
                          lastName={isIndivitual ? user?.LastName : activeChat?.project?.split(" ")[1]}
                          PhotoPath={isIndivitual ? ApiConfig.BASE_URL_FOR_IMAGES + user?.PhotoPath : activeChat?.GroupIcon ? activeChat?.GroupIcon : null}
                        />
                        {/* <img
                          src={
                            !currentRoute.includes("/projects") &&
                            user &&
                            user.PhotoPath
                              ? ApiConfig.BASE_URL_FOR_IMAGES + user.PhotoPath
                              : profile_img
                          }
                          alt=""
                          onError={(e) => (e.target.src = profile_img)}
                          width={"41px"}
                          className="rounded-circle"
                        /> */}
                      </Link>
                      {!currentRoute.includes("/projects") && (
                        <div className="indication-img status-img-shadow">
                          <img
                            src={
                              user &&
                              (user.user_status == "online"
                                ? ic_online
                                : user.user_status == "busy" ||
                                  user.user_status == "do not desturb"
                                  ? ic_busy
                                  : user.user_status == "away"
                                    ? ic_away
                                    : ic_gray)
                            }
                            alt=""
                          />
                        </div>
                      )}
                    </div>
                    <div className="comm-chatbox__header-info">
                      <span className="comm-chatbox__header-name" onClick={() => setMembers(true)}>
                        {currentRoute?.includes("/projects") && activeChat
                          ? activeChat?.project +
                          " >  " +
                          activeChat?.Team_Channel_Name
                          : currentRoute?.includes("/teams") && activeChat
                            ? activeChat?.project +
                            " >  " +
                            activeChat?.Team_Channel_Name
                            : activeChat?.Team_Channel_Description &&
                              activeChat?.Team_Channel_Description != undefined &&
                              activeChat?.Team_Channel_Description != null &&
                              activeChat?.Team_Channel_Description != "private"
                              ? activeChat?.Team_Channel_Description
                              : activeChat?.em?.length == 2
                                ? user && user.FirstName + " " + user.LastName
                                : user &&
                                user.FirstName +
                                " " +
                                user.LastName +
                                " " +
                                (activeChat?.em?.length - 1 > 1
                                  ? "   " +
                                  activeChat?.em?.length -
                                  1 +
                                  " & others"
                                  : "")}
                      </span>
                      <div className="comm-chatbox__header-status">
                        {user && (
                          <>

                            <span className="comm-chatbox__header-status-label">
                              {user?.user_status == "offline" ? (
                                user?.last_seen && "Last Seen :"
                              ) : (
                                <>
                                  {user?.user_status}
                                  {"  "}
                                </>
                              )}
                              &nbsp; &nbsp;
                            </span>
                            <span className="comm-chatbox__header-status-text">
                              {" " + user &&
                                user?.user_status == "offline" &&
                                user?.last_seen &&
                                moment(last_seen)?.fromNow() + " "}
                              {(user?.EmployeeStatusMessage?.length > 0
                                ? user?.EmployeeStatusMessage
                                : user?.EmployeeLiveMessage) && (
                                <span className="comm-chatbox__header-status-pill">
                                  {user?.EmployeeStatusMessage?.length > 0
                                    ? user?.EmployeeStatusMessage
                                    : user?.EmployeeLiveMessage}
                                </span>
                              )}
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="comm-chatbox__header-right">
                    {permissions && permissions["Calling Feature"] && (
                      <button
                        type="button"
                        className="comm-chatbox__call-btn"
                        aria-label="Start call"
                        disabled={!socket}
                        onClick={() => {
                          socket &&
                            socket.emit("call-initiate", {
                              schannel_id: currentSChannel,
                              os_type: "web",
                            });
                        }}
                      >
                        <img src={bx_phone_call} alt="" aria-hidden="true" />
                      </button>
                    )}
                    {/* <Link to="#" className="right-icon-chat">
                    <img src={ic_video_call} alt="" />
                  </Link> */}
                    <Dropdown className="ActionDropdown comm-chatbox__header-action">
                      <Dropdown.Toggle
                        variant="success"
                        id="dropdown-basic"
                        className="ActionToggle"
                        ref={pindropdown}
                      >
                        <img src={more_vertical} alt="" />
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="ActionMenu">
                        <ul className="actionnmenulist">
                          {!currentRoute.includes("projects") &&
                            !currentRoute.includes("teams") && (
                              <li
                                onClick={() =>
                                  activeChat?.pin && activeChat?.pin
                                    ? unpinChat()
                                    : pinChat()
                                }
                              >
                                {activeChat?.pin && activeChat?.pin
                                  ? "Unpin"
                                  : "Pin"}{" "}
                              </li>
                            )}
                          {/* <li>Hide</li> */}
                          {currentRoute.includes("projects") && (
                            <li

                              onClick={() => {
                                setAddSubMembers(true); // Open the modal or perform related action
                                createSubChannelMember(); // Call the function to create sub-channel member
                              }}

                            >
                              Add Member
                            </li>
                          )}

                          {currentRoute.includes("chat") && (
                            <li onClick={() => setAddMembers(true)}>
                              Add People
                            </li>
                          )}
                          {/* <li>Screen Sharing</li> */}
                          <li onClick={() => setFiles(true)}>Files</li>
                          {/* <li>Delete Chat</li> */}
                          <li onClick={() => setMembers(true)}>About</li>
                          <li onClick={handleCopyUrl}>Copy Webhook</li>
                        </ul>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
                {files ? (
                  <Files handleClose={setFiles} />
                ) : (
                  <>
                    {loading ? (
                      <div className="comm-chatbox__body">
                        <Beatloader />
                      </div>
                    ) : (
                      <MessageList
                        conversations={conversations}
                        newMessages={newMessages}
                        userData={userData}
                        socket={socket}
                        currentSChannel={currentSChannel}
                        membersArray={membersArray}
                        editMsg={editMsg}
                        setEditMsg={setEditMsg}
                        replyTo={replyTo}
                        setReplyTo={setReplyTo}
                        selectedReaction={selectedReaction}
                        setselectedReaction={setselectedReaction}
                        noMorePages={noMorePages}
                        paginationLoader={paginationLoader}
                        page={page}
                        setPage={setPage}
                        firstMsg={firstMsg}
                        lastMsg={lastMsg}
                        msgRef={msgRef}
                        inputRef={inputRef}
                        addCreateTask={addCreateTask}
                        deletMessage={deletMessage}
                        removeReaction={removeReaction}
                      />
                    )}

                    <UploadTray
                      uploadedFiles={uploadedFiles}
                      setUploadedFiles={setUploadedFiles}
                    />

                    <Composer
                      emogi={emogi}
                      setEmogi={setEmogi}
                      message={message}
                      setmessage={setmessage}
                      uploadedFiles={uploadedFiles}
                      setUploadedFiles={setUploadedFiles}
                      replyTo={replyTo}
                      setReplyTo={setReplyTo}
                      menstionedUsers={menstionedUsers}
                      setMenstionedUsers={setMenstionedUsers}
                      inputRef={inputRef}
                      msgRef={msgRef}
                      recentChats={recentChats}
                      setRecentChats={setRecentChats}
                      pinnedChats={pinnedChats}
                      setPinnedChats={setPinnedChats}
                      activeChat={activeChat}
                      sendMessage={sendMessage}
                      userTyping={userTyping}
                      userData={userData}
                      currentSChannel={currentSChannel}
                      toast={toast}
                      items={items}
                    />
                  </>
                )}

                <input
                  type="file"
                  className="d-none"
                  ref={fileUpload}
                  multiple
                  onChange={(e) => {
                    e.preventDefault();
                    const newFiles = Array.from(e.target.files);
                    setUploadedFiles((prevFiles) => [
                      ...prevFiles,
                      ...newFiles,
                    ]);
                    if (fileUpload.current) {
                      fileUpload.current.value = null;
                    }
                  }}
                />
              </>
            ) : (
              <div className="noMsgsBlog h-100">
                <img src={no_chats} className="chatsImg" alt="" /> <br />
                <span> No Active chat found </span>
              </div>
            )}
          </>
        )}

        <UIModal
          show={openVoiceReq}
          onHide={() => {
            closeOutsideClick && setOpenVoiceReq(false);
          }}
          title="Send Voice Message"
          size="md"
        >
          <div className="comm-voice-recorder">
            <AudioRecording
              submitRecording={(record) => {
                const file = new File([record], "6367.mp3", {
                  type: "audio/mp3",
                });
                console.log(record, file);
                setUploadedFiles([...uploadedFiles, file]);
                setOpenVoiceReq(false);
              }}
              closeOutsid={() => setCloseOutSideClic(false)}
            />
          </div>
        </UIModal>

        <UIModal
          show={showAudioErr}
          size="md"
          onHide={() => {
            setShowAudioErr(false);
          }}
          title="Microphone Not Connected!"
          footer={
            <UIButton
              variant="primary"
              onClick={() => setShowAudioErr(false)}
            >
              Got it
            </UIButton>
          }
        >
          <div className="comm-mic-error">
            <span className="comm-mic-error__icon" aria-hidden="true">!</span>
            <p className="comm-mic-error__message">
              Please connect your microphone to record a voice message.
            </p>
          </div>
        </UIModal>

        <UIModal
          show={members}
          onHide={() => {
            setMembers(false);
          }}
          size="xl"
          title="Members"
        >
          {/* For Admin only */}
          <form className="row">
            {activeChat?.Team_Channel_Description &&
              activeChat?.Team_Channel_Description &&
              activeChat?.em?.length > 2 && (
                <>
                  <div class="form-group col-lg-4">
                    <UIInput
                      type="text"
                      value={schannelName}
                      onChange={(e) => setSchannelName(e.target.value)}
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                      placeholder="Enter Team Channel Name"
                    />
                  </div>

                  <UIButton
                    variant="primary"
                    className="col-lg-1"
                    onClick={() => {
                      socket &&
                        socket.emit("update-schannel-name", {
                          Team_Channel_Description: schannelName,
                          schannel_id: currentSChannel,
                        });

                      setMembers(false);
                      notifySuccess("Group Name Updated successfully");
                    }}
                  >
                    Update
                  </UIButton>
                </>
              )}
          </form>
          <div className="table-Model mb-4">
            <UITable>
              <thead>
                <tr className="firstTabelRow">
                  <th>Sr. no</th>
                  <th>Name</th>
                  {
                    currentRoute == '/teams' &&
                    <>
                      <th>Primary Profile</th>
                      <th>Secondary Profile</th>
                    </>
                  }
                  <th>Teams</th>
                  <th>Branch</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {membersArray &&
                  membersArray
                    // .filter((item) => item?.User_Id != "everyone")
                    // .filter((item) => {
                    //   if (membersArray.length === 2) {
                    //     return item?.User_Id != userData?.EmpId;
                    //   } else {
                    //     return item;
                    //   }
                    // })
                    .map((member, index) => {
                      return (
                        <tr
                          className="table-row-main"
                          key={"member " + index}
                        >
                          <td>{index + 1}</td>
                          <td
                            onClick={() => {
                              console.log(member)
                              navigate("/Profile/" + member?.User_Id)
                            }
                            }

                          >
                            <div className="comm-chatbox__member-cell">
                              <ChatImage
                                PhotoPath={
                                  ApiConfig.BASE_URL_FOR_IMAGES + member.PhotoPath}
                                name={member.FirstName}
                                lastName={member.LastName}
                              />
                              <span >{member.FirstName + " " + member.LastName}</span>

                              {/* <span>Admin</span> */}
                            </div>
                          </td>
                          {
                            currentRoute == '/teams' &&
                            <>
                              <td>{member?.primaryProfileName}</td>
                              <td>{member?.secondaryProfileName}</td>
                            </>
                          }
                          <td>{member.TeamName}</td>
                          <td>{member.LocationName}</td>
                          {/* <td>{member.last_seen != null && moment(member.last_seen).fromNow()}</td> */}
                          <td>
                            {activeChat?.Team_Channel_Name !== "General" &&
                              activeChat?.em &&
                              activeChat?.em.length > 1 ? (
                              <Dropdown
                                className="ActionDropdown"
                                id="Drop_ActionDropdown"
                              >
                                <Dropdown.Toggle
                                  variant="success"
                                  id="dropdown-basic"
                                  className="ActionToggle"
                                  ref={pindropdown}
                                >
                                  <img src={more_vertical} alt="" />
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="ActionMenu">
                                  <ul className="actionnmenulist">
                                    <li
                                      onClick={() => {
                                        socket &&
                                          socket.emit("remove-member", {
                                            schannel_id: currentSChannel,
                                            memberId: member.User_Id,
                                          });
                                      }}
                                    >
                                      Remove
                                    </li>
                                  </ul>
                                </Dropdown.Menu>
                              </Dropdown>
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      );
                    })}
              </tbody>
            </UITable>
            {activeChat?.Team_Channel_Name !== "General" &&
              activeChat?.Team_Channel_Description &&
              activeChat?.Team_Channel_Description &&
              activeChat?.em?.length > 2 && (
                <UIButton
                  variant="ghost"
                  onClick={() => {
                    setMembers(false);
                    setAddMembers(true);
                  }}
                >
                  +Add Member
                </UIButton>
              )}
          </div>
        </UIModal>
        <UIModal
          show={addMembers}
          onHide={() => {
            setAddMembers(false);
          }}
          size="lg"
          title="Add Members"
          footer={
            <div className="d-flex justify-content-end align-items-center mainBtnsSub py-3 px-3 w-100">
              <UIButton
                variant="secondary"
                className="mx-3"
                onClick={() => {
                  setAddMembers(false);
                  setMembers(true);
                }}
              >
                Cancel
              </UIButton>
              <UIButton
                variant="primary"
                onClick={() => {
                  save();
                  setAddMembers(false);
                }}
              >
                Add
              </UIButton>
            </div>
          }
        >
          <div className="row px-3">
            <div className="col-lg-12 pe-0 mb-2">
              <label for="" class="mb-2 text-grey">
                Employee Name
              </label>
              <Multiselect
                options={
                  currentRoute.includes("projects")
                    ? teamMembers
                      .filter(
                        (member) =>
                          !membersArray
                            .map((chanMember) => chanMember.User_Id)
                            .includes(member.User_Id)
                      )
                      .map((member) => {
                        return {
                          id: member.User_Id,
                          name: member.FirstName + " " + member.LastName,
                        };
                      })
                    : suggetions
                      .filter(
                        (member) =>
                          !membersArray
                            .map((chanMember) => chanMember.User_Id)
                            .includes(member.EmployeeId)
                      )
                      .map((member) => {
                        return {
                          id: member.EmployeeId,
                          name: member.FirstName + " " + member.LastName,
                        };
                      })
                } // Options to display in the dropdown
                // selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                onSelect={(selectedList) => {
                  setMembersAdded(selectedList);
                }} // Function will trigger on select event
                onRemove={(selectedList) => {
                  setMembersAdded(selectedList);
                }} // Function will trigger on remove event
                displayValue="name" // Property name to display in the dropdown options
                closeOnSelect="false"
              />
            </div>
          </div>
        </UIModal>

        {/* Sab chainal  */}

        <UIModal
          show={addSubMembers}
          onHide={() => {
            setAddSubMembers(false);
          }}
          size="lg"
          title="Add Sub Members"
          footer={
            <div className="d-flex justify-content-end align-items-center mainBtnsSub py-3 px-3 w-100">
              <UIButton
                variant="secondary"
                className="mx-3"
                onClick={() => {
                  setAddSubMembers(false);
                  setMembers(true);
                }}
              >
                Cancel
              </UIButton>
              <UIButton
                variant="primary"
                onClick={() => {
                  save();
                  setAddSubMembers(false);
                }}
              >
                Add Update
              </UIButton>
            </div>
          }
        >
          <div className="row px-3">
            <div className="col-lg-12 pe-0 mb-2">
              <label for="" class="mb-2 text-grey">
                Employee Name
              </label>
              <Multiselect
                options={
                  SubchianlMemberList

                    .map((member) => ({
                      id: member.EmployeeId,
                      name: `${member.FirstName} ${member.LastName}`,
                    }))
                }
                // selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                onSelect={(selectedList) => {
                  setMembersAdded(selectedList);
                }} // Function will trigger on select event
                onRemove={(selectedList) => {
                  setMembersAdded(selectedList);
                }} // Function will trigger on remove event
                displayValue="name" // Property name to display in the dropdown options
                closeOnSelect="false"
              />
            </div>
          </div>
        </UIModal>
      </div>
    </>
  );
};

export default memo(ChatBox);
